import * as ReactDOM from "react-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import styles from "../styles/components/overlay.module.css";

const Overlay = ({ children, handleClose }) => {
  const overlayRoot = document.getElementById("overlay-root");

  // Prevent scrolling when overlay is visible
  useEffect(() => {
    const top = document.scrollingElement.scrollTop;
    document.body.style.position = "fixed";
    document.body.style.top = `-${top}px`;
    document.body.style.width = "100%";
    document.body.style.overflowY = "hidden";
    document.body.style.height = "auto";
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflowY = "";
      document.body.style.paddingRight = "";
      document.documentElement.style.scrollBehavior = "auto";
      window.scrollTo({
        left: 0,
        top: parseInt(scrollY || "0") * -1,
        behavior: "auto",
      });
    };
  }, []);

  return ReactDOM.createPortal(
    <motion.div
      key={"overlay"}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      exit={{ opacity: 0 }}
      className={styles.overlay}
      onClick={() => handleClose()}
    >
      {children}
    </motion.div>,
    overlayRoot
  );
};

export default Overlay;
